import React from 'react';
import style from '../components/blocks/Modal/Modal.module.scss';

const getSourceСomplainants: React.FC = (response: any) => {
  const { items } = response;
  if (!items || items.length === 0) {
    return null;
  }
  return (
    <>
      {items.map((el: any) => (
        <tr className={style.resultRow}>
          <td className={style.complainantsTableResultDate}>
            <div className={style.complainantsTableResultDate}>{el.filed_at || '-'}</div>
          </td>
          <td className={style.complainantsTableResultComplaintNumber}>
            <div className={style.complainantsTableResultComplaintNumber}>{el.registry_id || '-'}</div>
          </td>
          <td className={style.complainantsTableResultPurchaseNumber}>
            <div className={style.complainantsTableResultPurchaseNumber}>{el.procedure_registry_id || '-'}</div>
          </td>
          <td className={style.complainantsTableResultPurchase}>
            <div className={style.complainantsTableResultPurchase}>{el.procedure_description || '-'}</div>
          </td>
        </tr>
      ))}
    </>
  );
};
export default getSourceСomplainants;
